/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import detectIt from 'detect-it';

const useInfiniteScroll = (callback, scrollElement) => {
  const [isFetching, setIsFetching] = useState(false);
  const [fetchedExtra, setFetchedExtra] = useState(false);

  const getPageHeight = () =>
    scrollElement?.scrollHeight || document.documentElement.offsetHeight;

  const getWindowHeight = () =>
    scrollElement?.offsetHeight || window.innerHeight;

  const getScrollPosition = () =>
    scrollElement?.scrollTop ||
    window.scrollY ||
    window.pageYOffset ||
    document.body.scrollTop +
      ((document.documentElement && document.documentElement.scrollTop) || 0);

  function handleScroll() {
    const pageHeight = getPageHeight();
    const windowHeight = getWindowHeight();
    const scrollPosition = getScrollPosition();
    if (pageHeight - 350 <= windowHeight + scrollPosition) {
      if (!isFetching) setIsFetching(true);
    }
  }

  useEffect(() => {
    const pageHeight = getPageHeight();
    const windowHeight = getWindowHeight();
    const scrollPosition = getScrollPosition();
    // Check if the height of the window or scrollElement is not scrollable due to the pageHeight being less than or equal to the window height.
    if (scrollPosition === 0 && windowHeight >= pageHeight && !fetchedExtra) {
      // Load some data to fill some extra info to populate till scroll.
      setFetchedExtra(true); // To ensure that in case there is no data due to which the screen is blank, there isn't an infinite API call sequence.
      setTimeout(() => {
        setIsFetching(true);
      }, 1000);
    }
    if (scrollElement) {
      scrollElement.addEventListener(
        'scroll',
        handleScroll,
        detectIt.passiveEvents === true
          ? { capture: false, passive: true }
          : false
      );
      return () => scrollElement.removeEventListener('scroll', handleScroll);
    }
    window.addEventListener(
      'scroll',
      handleScroll,
      detectIt.passiveEvents === true
        ? { capture: false, passive: true }
        : false
    );
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isFetching) return;
    const timeout = setTimeout(callback, 100);
    return () => clearTimeout(timeout);
  }, [isFetching]);

  return [isFetching, setIsFetching];
};

export default useInfiniteScroll;
